import React from 'react';
import { amcTitleCase } from '../../utils';
import amcStyles from '../../styles/amcs.scss';

interface HowToInvestProps {
  issuingAuthority: string;
}

const HowToInvest: React.FC<HowToInvestProps> = ({ issuingAuthority }) => {
  return (
    <div className="lil-pt-12 sm:lil-pt-0">
      <h2
        className={`${amcStyles['plan-title']} lil-pt-4 lil-pb-8 sm:lil-pb-6 sm:lil-pt-0`}
      >
        How to Invest in {amcTitleCase(issuingAuthority)}
      </h2>
      <div
        className="lil-flex lil-ml-4 sm:lil-ml-0 lil-mb-4 sm:lil-mb-3"
        style={{ alignItems: 'flex-start' }}
      >
        <div className="lil-bg-blue-50 lil-rounded-xxl lil-px-4 lil-py-1 lil-font-medium lil-whitespace-nowrap lil-flex-shrink-0">
          Step 1
        </div>
        <div className="lil-ml-6 lil-py-1 sm:lil-ml-4">
          You may consider logging on to cleartax invest.
        </div>
      </div>
      <div
        className="lil-flex lil-ml-4 sm:lil-ml-0 lil-mb-4 sm:lil-mb-3"
        style={{ alignItems: 'flex-start' }}
      >
        <div className="lil-bg-blue-50 lil-rounded-xxl lil-px-4 lil-py-1 lil-font-medium lil-whitespace-nowrap lil-flex-shrink-0">
          Step 2
        </div>
        <div className="lil-ml-6 lil-py-1 sm:lil-ml-4">
          You then select {amcTitleCase(issuingAuthority)} from the list of the
          fund houses.
        </div>
      </div>
      <div
        className="lil-flex lil-ml-4 sm:lil-ml-0 lil-mb-4 sm:lil-mb-3"
        style={{ alignItems: 'flex-start' }}
      >
        <div className="lil-bg-blue-50 lil-rounded-xxl lil-px-4 lil-py-1 lil-font-medium lil-whitespace-nowrap lil-flex-shrink-0">
          Step 3
        </div>
        <div className="lil-ml-6 lil-py-1 sm:lil-ml-4">
          Pick the mutual fund scheme where you plan to put money and click on
          Invest now.
        </div>
      </div>
      <div
        className="lil-flex lil-ml-4 sm:lil-ml-0 lil-mb-4 sm:lil-mb-3"
        style={{ alignItems: 'flex-start' }}
      >
        <div className="lil-bg-blue-50 lil-rounded-xxl lil-px-4 lil-py-1 lil-font-medium lil-whitespace-nowrap lil-flex-shrink-0">
          Step 4
        </div>
        <div className="lil-ml-6 lil-py-1 sm:lil-ml-4">
          You may select the amount you plan to invest in the mutual fund scheme
          and the mode as One Time or Monthly SIP.
        </div>
      </div>
      <div
        className="lil-flex lil-ml-4 sm:lil-ml-0 lil-mb-4 sm:lil-mb-0"
        style={{ alignItems: 'flex-start' }}
      >
        <div className="lil-bg-blue-50 lil-rounded-xxl lil-px-4 lil-py-1 lil-font-medium lil-whitespace-nowrap lil-flex-shrink-0">
          Step 5
        </div>
        <div className="lil-ml-6 lil-py-1 sm:lil-ml-4">
          You then fill up the relevant details such as email ID, mobile number
          and complete the transaction.
        </div>
      </div>
    </div>
  );
};

export default HowToInvest;



// WEBPACK FOOTER //
// ./components/amcNew/HowToInvest.tsx